import Button from '@mui/material/Button';
import { useTranslation } from 'react-i18next';

import { Dialog, DialogContent } from '@work4all/components';

interface WorkTimeDisabledAlertProps {
  open: boolean;
  onClose: () => void;
}

// TODO: WW-6474 There are many alerts like this in the app and it's rather cumbersome to
// maintain their state manually in the parent component when there aren't
// really any actions a user can perform on such alert rather than just
// dismissing it.
export function WorkTimeDisabledAlert(props: WorkTimeDisabledAlertProps) {
  const { open, onClose } = props;

  const { t } = useTranslation();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      closeButton={false}
      title={t('COMMON.TIMETRACKING.NO_PROJECTTIME_LICENSE.LABEL')}
    >
      <DialogContent>
        <p>{t('COMMON.TIMETRACKING.NO_PROJECTTIME_LICENSE.DESCRIPTION')}</p>

        <Button fullWidth size="large" color="primary" onClick={onClose}>
          {t('ALERTS.CLOSE')}
        </Button>
      </DialogContent>
    </Dialog>
  );
}
